import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const getStoreDealer = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-store-dealer`
});

export const getStores = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-stores`,
  body: storeInfo
});

export const getIndexSa = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/store/get-store-ba?${storeInfo}`,
});

export const getIndexCustomer = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/store/get-store-member?${storeInfo}`,
});

export const getIndexReservation = (storeInfo) => callApi({
  method: 'GET',
  endpoint: `${basePath}/store/get-reservation`,
  body: storeInfo
});

export const getStorePersonnel = (store_id) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-store-personnel`,
  body: {
    store_id
  }
});

export const updateSa = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/store-manage/update-sa/${updateInfo.sa_id}`,
  body: updateInfo
});
export const changeMemberSa = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/store/change-member-ba`,
  body: updateInfo
});

export const getBirthMemberList = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/contacts/get-birth-member-list`,
  body: updateInfo
});

export const getExpireRemindMemberList = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/contacts/get-member-expiration-reminder-list`,
  body: updateInfo
});
